module.exports = __webpack_public_path__ + "img/schlosserei-raichle-logo-slogan.87e3e103.webp";